import { useQuery } from "@tanstack/react-query";

import { PRACTICE_MANAGEMENT_ENDPOINTS, getPracticeManagementSoilEmissionsFactor } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_SOIL_EMISSION_FACTORS } from "consts";

export const usePracticeManagementSoilEmissionFactors = (version?: string, country: PracticeManagement.CountryCode = "global") =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_SOIL_EMISSION_FACTORS, country, version],
    // Country-only resource: one row, and no domain-specific key, so the endpoint path stands in as the editing key
    queryFn: async () => {
      const factor = await getPracticeManagementSoilEmissionsFactor(version, country);
      return {
        ...factor,
        editingKey: PRACTICE_MANAGEMENT_ENDPOINTS.SOIL_EMISSION_FACTORS,
      };
    },
    staleTime: 1000 * 60 * 60, // 1h
    gcTime: 1000 * 60 * 24, // 24h
  });
